import {
    FETCH_TEAM_DATA_REQUEST,
    FETCH_TEAM_DATA_SUCCESS,
    FETCH_TEAM_DATA_FAILURE,
    ADD_TEAM_DATA_REQUEST,
    ADD_TEAM_DATA_SUCCESS,
    ADD_TEAM_DATA_FAILURE,
    UPDATE_TEAM_DATA_REQUEST,
    UPDATE_TEAM_DATA_SUCCESS,
    UPDATE_TEAM_DATA_FAILURE,
    DELETE_TEAM_DATA_REQUEST,
    DELETE_TEAM_DATA_SUCCESS,
    DELETE_TEAM_DATA_FAILURE,
    TOGGLE_ACTIVE_REQUEST,
    TOGGLE_ACTIVE_SUCCESS,
    TOGGLE_ACTIVE_FAILURE,
} from './actionType';

const initialState = {
    teamData: [],
    status: 'idle',
    error: null,
};

const teamReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TEAM_DATA_REQUEST:
        case ADD_TEAM_DATA_REQUEST:
        case UPDATE_TEAM_DATA_REQUEST:
        case DELETE_TEAM_DATA_REQUEST:
        case TOGGLE_ACTIVE_REQUEST:
            return { ...state, status: 'loading', error: null };
        case FETCH_TEAM_DATA_SUCCESS:
            return { ...state, status: 'succeeded', teamData: action.payload, error: null };
        case FETCH_TEAM_DATA_FAILURE:
        case ADD_TEAM_DATA_FAILURE:
        case UPDATE_TEAM_DATA_FAILURE:
        case DELETE_TEAM_DATA_FAILURE:
        case TOGGLE_ACTIVE_FAILURE:
            return { ...state, status: 'failed', error: action.payload };
        case ADD_TEAM_DATA_SUCCESS:
            return { ...state, status: 'succeeded', teamData: [...state.teamData, action.payload], error: null };
        case UPDATE_TEAM_DATA_SUCCESS:
            console.log('action.payload in reducer:', action.payload);
            return {
                ...state,
                status: 'succeeded',
                teamData: state.teamData.map((member) =>
                    member.id === action.payload._id ? { ...member, ...action.payload } : member
                ),
                error: null,
            };
        case DELETE_TEAM_DATA_SUCCESS:
            return {
                ...state,
                status: 'succeeded',
                teamData: state.teamData.filter((member) => member.id !== action.payload.id),
                error: null,
            };
        case TOGGLE_ACTIVE_SUCCESS:
            return {
                ...state,
                status: 'succeeded',
                teamData: state.teamData.map((member) =>
                    member.id === action.payload.id ? { ...member, isActive: action.payload.isActive } : member
                ),
                error: null,
            };
        default:
            return state;
    }
};

export default teamReducer;